import React, { useCallback } from 'react';
import { Tooltip } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import cx from 'classnames';

import { useAppDispatch, useAppSelector } from 'hooks/store';
import { AppPageSelector, PlatformIframeViewEnabledSelector, setPage } from 'store/common';

import { useAllowedMenuItems } from './constants';
import { REFRESH_TOKEN, TOKEN, USER_ID } from 'constants/localStorage';
import { Pages } from 'constants/pages';

import { LOGIN } from 'router/routes';

import HelpMenu from 'components/HelpMenu';
import CompanyPolicies from 'components/CompanyPolicies';
import ThemeSwitch from 'components/Sidebar/components/ThemeSwitch';

import { ReactComponent as LogOutIcon } from 'assets/icons/logout.svg';
import { ReactComponent as HomeIcon } from 'assets/icons/home.svg';

import useStyles from './styles';

const Sidebar: React.FC = () => {
  const classes = useStyles();
  const navigate = useNavigate();
  const menuItems = useAllowedMenuItems();
  const dispatch = useAppDispatch();
  const platformIframeViewEnabled = useAppSelector(PlatformIframeViewEnabledSelector);
  const currentPage = useAppSelector(AppPageSelector);

  const handleClick = (page: string): void => {
    dispatch(setPage(page));
  };

  const handleRedirectHome = useCallback(() => {
    dispatch(setPage(Pages.Home));
  }, []);

  return (
    <div className={classes.sidebar}>
      {/* Profile */}
      <div
        className={cx(classes.listItem, classes.homeItem, {
          [classes.activeItem]: currentPage === Pages.Home,
          [classes.activeHoneItem]: currentPage === Pages.Home,
        })}
      >
        <Tooltip title="Home">
          <HomeIcon onClick={handleRedirectHome} />
        </Tooltip>

        <ThemeSwitch />
      </div>

      {/* Menu Items */}
      <div className={classes.menu}>
        {menuItems.map(i => (
          <Tooltip title={i.text} key={i.text}>
            <div
              className={cx(classes.listItem, { [classes.activeItem]: currentPage === i.page })}
              onClick={() => {
                handleClick(i.page);
              }}
            >
              {i.icon}
            </div>
          </Tooltip>
        ))}
      </div>

      {/* Footer Menu */}
      <div
        className={classes.listItem}
        style={{ marginTop: 'auto', display: 'flex', flexDirection: 'column', gap: '25px' }}
      >
        <CompanyPolicies />
        <HelpMenu />
        {!platformIframeViewEnabled && (
          <LogOutIcon
            style={{ color: 'white' }}
            onClick={() => {
              localStorage.removeItem(TOKEN);
              localStorage.removeItem(REFRESH_TOKEN);
              localStorage.removeItem(USER_ID);
              navigate(LOGIN);
            }}
          />
        )}
      </div>
    </div>
  );
};

export default Sidebar;
